export default "__VITE_ASSET__e5$YhEn1__"